import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidateStatusPipe } from './validate-status.pipe';
import { IsEmptyPipe } from './is-empty.pipe';
import { VehiclesCountPipe } from './vehicles-count.pipe';
import { SlicePipe } from './slice.pipe';
import { PhonePipe } from './phone.pipe';
import { StatusTranslatorPipe } from './status-translator.pipe';
import { GlobalSearchTranslatorPipe } from './globall-search-translator.pipe';
import { ShipviaTranslatorPipe } from './shipvia-translator.pipe';
import { TooltipColorPipe } from './tooltip-color.pipe';
import { ColorRankingPipe } from './color-ranking.pipe';
import { TruncatePipe } from './truncate.pipe';
import { CustomTitleCasePipe } from './custom-title-case.pipe';
import { GetTariffPipe } from './get-tariff.pipe';
import { MercuryOrderTypePipe } from './mercury-order-type.pipe';

@NgModule({
  declarations: [
    ValidateStatusPipe,
    IsEmptyPipe,
    VehiclesCountPipe,
    SlicePipe,
    PhonePipe,
    StatusTranslatorPipe,
    GlobalSearchTranslatorPipe,
    ShipviaTranslatorPipe,
    TooltipColorPipe,
    ColorRankingPipe,
    TruncatePipe,
    CustomTitleCasePipe,
    GetTariffPipe,
    MercuryOrderTypePipe
  ],
  imports: [CommonModule],
  exports: [
    ValidateStatusPipe,
    IsEmptyPipe,
    VehiclesCountPipe,
    SlicePipe,
    PhonePipe,
    StatusTranslatorPipe,
    GlobalSearchTranslatorPipe,
    ShipviaTranslatorPipe,
    TooltipColorPipe,
    ColorRankingPipe,
    TruncatePipe,
    CustomTitleCasePipe,
    GetTariffPipe,
    MercuryOrderTypePipe
  ]
})
export class PipesModule {}
